import { Stack, Button, Loader, useMantineTheme } from "@mantine/core";
import {
  PronosticV2,
  PronosticV2Element,
  isInputLikeElement,
} from "pronosticsv2/types/pronosticv2.model";
import { PlayPronosticV2Form } from "../components/PlayPronosticV2Form";
import { useEffect, useState } from "react";
import { MessageScreen } from "../components/MessageScreen";
import { PronosticPredictionsDisplay } from "../components/PronosticResultDisplay";
import {
  useAddPlayerMutation,
  useGetPlayerQuery,
} from "quiz/api/players.endpoints";
import { useSavedPronosticV2 } from "pronosticsv2/hooks/useSavedPronostic";
import { Footer } from "event/play/components/Footer";
import { PronosticHeader } from "../components/PronosticHeader";
import { EventHeader } from "event/play/components/EventHeader";
import { renderWithLineBreaks } from "common/utils/renderWithLineBreaks";
import { isValidUrl } from "../components/PlayPronosticV2Form";

interface PlayPronosticsV2ViewProps {
  pronosticV2: PronosticV2;
  playerId: string;
  partitionId: string;
  playerInfo: any;
  subPlace: string;
  refreshPronosticV2: () => void;
}

type ScreenType = "P1" | "P2" | "P3" | "P4";

export const PlayPronosticsV2View: React.FC<PlayPronosticsV2ViewProps> = ({
  pronosticV2,
  playerId,
  partitionId,
  playerInfo,
  subPlace,
  refreshPronosticV2,
}) => {
  // Get the theme from MantineProvider to access the font
  const theme = useMantineTheme();

  //using hooks
  const [currentScreen, setCurrentScreen] = useState<ScreenType>("P1");
  const [errorMesaage, setErrorMessage] = useState<string | null>(null);
  const {
    data: fetchedPlayer,
    isLoading: isPlayerLoading,
    refetch: refetchPlayer,
  } = useGetPlayerQuery([playerId, partitionId], {
    skip: !playerId || !partitionId,
  });
  const [addPlayer] = useAddPlayerMutation();
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const [savedPronosticV2, setSavedPronosticV2] = useSavedPronosticV2(
    pronosticV2.id,
  );
  // const navigate = useNavigate();

  //linting error suppression
  void error;
  void success;
  void savedPronosticV2;
  const [resolvedSubPlace, setResolvedSubPlace] = useState<string>("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentScreen]);

  //helper function
  const refreshPlayer = async () => {
    try {
      refetchPlayer();
    } catch (error) {
      console.error("Error refreshing data:", error);
    }
  };

  const formatName = (fullName: string) => {
    const parts = fullName.trim().split(" ");
    if (parts.length === 0) return fullName;
    const firstName = parts[0];
    const lastNameInitial =
      parts.length > 1 ? parts[parts.length - 1][0].toUpperCase() : "";
    return lastNameInitial ? `${firstName} ${lastNameInitial}` : firstName;
  };

  // check if subplace is zero
  //if zero, find list of subplaces from pronostic object
  // if subplace list length is one, subplace=subplace array[0].id
  // if subplace list length is any other condition, redirect to /event?errormessage=contact admin
  useEffect(() => {
    if (subPlace === "0") {
      const subPlaceList =
        pronosticV2.commonSettings.general.moduleSettings.place.subPlaces;
      console.log("subPlaceList", subPlaceList);
      if (subPlaceList.length === 1 && subPlaceList[0].id) {
        setResolvedSubPlace(subPlaceList[0].id);
      } else {
        // navigate("../../../..?error=NoSubPlace");
        setErrorMessage(
          "Vous n'êtes pas localisé correctement, veuillez contacter l'organisateur",
        );

        return; // Prevent further execution
      }
    } else {
      setResolvedSubPlace(subPlace); // Use the provided subPlace if not "0"
    }
  }, [subPlace, pronosticV2]);

  const playerCreationPayload = {
    playerInfo: playerInfo,
    subPlaceId: resolvedSubPlace,
    pronosticV2Id: pronosticV2.id,
    pronosticInfo: {
      pronosticV2Id: pronosticV2.id,
      subPlace: subPlace,
      prediction: pronosticV2.specificSettings.pronosticResults.map(
        (prono) => ({
          index: prono.pronosticIndex,
          values: [],
        }),
      ),
    },
  };

  const handlePlayerRegistration = async () => {
    if (playerId || partitionId) {
      console.log("Player already registered");
      return;
    }
    setError(null);
    setSuccess(false);
    try {
      const newPlayer = await addPlayer(playerCreationPayload).unwrap();
      setSavedPronosticV2({
        playerId: newPlayer.id,
        partitionId: newPlayer.partitionId,
      });

      setSuccess(true);
      console.log("newPlayer created");
      // onSuccess(newPlayer.id, newPlayer.partitionId); // 👈 callback
    } catch (err: any) {
      console.error("Error registering player:", err);
      setError("Failed to register player. Please try again.");
    }
  };
  // console.log("endAt", new Date(pronosticV2.specificSettings.endAt).getTime());
  // console.log("now", new Date().getTime());
  //console.log("resolvedsubplace", resolvedSubPlace);
  useEffect(() => {
    if (resolvedSubPlace) {
      handlePlayerRegistration();
    }
    // eslint-disable-next-line
  }, [resolvedSubPlace]);

  // On load, check if the player already submitted a prediction
  useEffect(() => {
    if (fetchedPlayer?.pronosticInfo) {
      setCurrentScreen("P3");
    }
  }, [fetchedPlayer]);

  // console.log("pronosticV2", pronosticV2);

  // console.log("subPlace", subPlace);

  // console.log("fetchedPlayer", fetchedPlayer);

  const currentSubPlace =
    pronosticV2.commonSettings.general.moduleSettings.place.subPlaces.find(
      (place) => place.id === resolvedSubPlace,
    );
  void currentSubPlace;
  //console.log("prono", pronosticV2.specificSettings.beginAt);
  //console.log("date", Date.now().toString());

  //screen logic starts here
  let content;
  if (!playerId || !partitionId) {
    if (errorMesaage) {
      content = (
        <div className="flex-1 flex flex-col h-full w-full px-4 py-8">
          <div className="flex justify-center items-center">
            <h1 className="text-center">
              {renderWithLineBreaks(errorMesaage)}
            </h1>
          </div>
        </div>
      );
    } else {
      content = <div>Player not registered yet</div>;
    }
    // content = <div>Player not registered yet</div>;
  } else {
    switch (currentScreen) {
      case "P1":
        if (
          pronosticV2.status === "not started" ||
          new Date(pronosticV2.specificSettings.beginAt).getTime() >
            new Date().getTime()
        ) {
          content = (
            <MessageScreen
              message={
                pronosticV2.commonSettings.webApp.texts.notStartedMessage
              }
              buttonLabel={
                pronosticV2.commonSettings.webApp.texts.refreshButtonLabel
              }
              buttonBgColor={
                pronosticV2.commonSettings.webApp.moduleSettings.buttonBgColor
              }
              buttonTextColor={
                pronosticV2.commonSettings.webApp.moduleSettings.buttonTextColor
              }
              messageColor={
                pronosticV2.commonSettings.webApp.moduleSettings
                  .messageTitleColor
              }
              messageSize={
                pronosticV2.commonSettings.webApp.moduleSettings
                  .messageTitleSize
              }
              onClick={() => {
                refreshPronosticV2();
              }}
            />
          );
        } else if (
          pronosticV2.status === "closed" ||
          new Date(pronosticV2.specificSettings.endAt).getTime() < Date.now()
        ) {
          content = (
            <MessageScreen
              message={pronosticV2.commonSettings.webApp.texts.tooLateMessage}
              buttonBgColor={
                pronosticV2.commonSettings.webApp.moduleSettings.buttonBgColor
              }
              buttonTextColor={
                pronosticV2.commonSettings.webApp.moduleSettings.buttonTextColor
              }
              messageColor={
                pronosticV2.commonSettings.webApp.moduleSettings
                  .messageTitleColor
              }
              messageSize={
                pronosticV2.commonSettings.webApp.moduleSettings
                  .messageTitleSize
              }
              onClick={() => {
                refreshPlayer();
                setCurrentScreen("P1");
              }}
            />
          );
        } else {
          content = (
            <PlayPronosticV2Form
              pronosticV2={pronosticV2}
              setScreen={() => setCurrentScreen("P2")}
              subPlace={fetchedPlayer?.pronosticInfo?.subPlace || subPlace}
              playerInfo={fetchedPlayer!}
              playerId={playerId}
              partitionId={partitionId}
            />
          );
        }

        break;
      case "P2":
        content = (
          <MessageScreen
            message={pronosticV2.commonSettings.webApp.texts.thankYouMessage}
            buttonLabel={
              pronosticV2.commonSettings.webApp.texts.backHomeButtonLabel
            }
            buttonBgColor={
              pronosticV2.commonSettings.webApp.moduleSettings.buttonBgColor
            }
            buttonTextColor={
              pronosticV2.commonSettings.webApp.moduleSettings.buttonTextColor
            }
            messageColor={
              pronosticV2.commonSettings.webApp.moduleSettings.messageTitleColor
            }
            messageSize={
              pronosticV2.commonSettings.webApp.moduleSettings.messageTitleSize
            }
            onClick={() => {
              refreshPlayer();
              setCurrentScreen("P3");
            }}
          />
        );

        break;
      case "P3":
        content = (() => {
          const pronostics =
            pronosticV2.commonSettings.general.moduleSettings.pronostics;
          type RenderItem =
            | {
                type: "single";
                pronostic: (typeof pronostics)[number];
                index: number;
              }
            | {
                type: "pair";
                first: (typeof pronostics)[number];
                second: (typeof pronostics)[number];
                firstIndex: number;
                secondIndex: number;
              };
          const groupedItems: RenderItem[] = [];
          let i = 0;
          while (i < pronostics.length) {
            const current = pronostics[i];
            const next = pronostics[i + 1];
            if (
              isInputLikeElement(current) &&
              current.element5FieldSize === 0 &&
              next &&
              isInputLikeElement(next) &&
              next.element5FieldSize === 0 &&
              current.element1Title === next.element1Title
            ) {
              groupedItems.push({
                type: "pair",
                first: current,
                second: next,
                firstIndex: i,
                secondIndex: i + 1,
              });
              i += 2;
            } else {
              groupedItems.push({
                type: "single",
                pronostic: current,
                index: i,
              });
              i += 1;
            }
          }

          const getPrediction = (index: number) =>
            fetchedPlayer?.pronosticInfo?.prediction?.find(
              (p) => p.index === pronostics[index].index,
            ) ?? { index: pronostics[index].index, values: [] };

          return (
            <div className="w-full flex flex-col items-center gap-4 mb-4">
              <div>
                {groupedItems.map((item) => {
                  if (item.type === "single") {
                    const prono = item.pronostic;
                    const index = item.index;
                    return (
                      <PronosticPredictionsDisplay
                        key={prono.index}
                        pronosticV2={pronosticV2}
                        pronosticIndex={prono.index}
                        header={
                          isInputLikeElement(prono)
                            ? prono.element1Title
                            : (prono as any).title
                        }
                        titleSize={
                          pronosticV2.commonSettings.webApp.moduleSettings
                            .pronoTitleSize
                        }
                        titleColor={
                          pronosticV2.commonSettings.webApp.moduleSettings
                            .pronoTitleColor
                        }
                        predictions={getPrediction(index)}
                      />
                    );
                  } else {
                    // Pair rendering
                    const first = item.first as PronosticV2Element;
                    const second = item.second as PronosticV2Element;
                    const firstPred = getPrediction(item.firstIndex);
                    const secondPred = getPrediction(item.secondIndex);
                    const [firstValue1 = null, firstValue2 = null] =
                      firstPred.values || [];
                    void firstValue2;
                    const [secondValue1 = null, secondValue2 = null] =
                      secondPred.values || [];
                    void secondValue2;
                    return (
                      <div
                        key={first.index}
                        className="flex flex-col items-center justify-center mt-8"
                      >
                        {/* Title (from first) */}
                        <div className="w-full ml-12">
                          <h1
                            className="text-left"
                            style={{
                              color:
                                pronosticV2.commonSettings.webApp.moduleSettings
                                  .pronoTitleColor,
                              fontSize:
                                pronosticV2.commonSettings.webApp.moduleSettings
                                  .pronoTitleSize,
                            }}
                          >
                            {first.element1Title}
                          </h1>
                        </div>

                        {/* Paired visuals and values */}
                        <div className="flex items-center justify-center gap-4">
                          {/* Left visual (from first) */}
                          <div className="flex flex-col w-[100px] mt-auto items-center">
                            {isValidUrl(first.element2Visual) &&
                              first.element2Visual && (
                                <img
                                  src={first.element2Visual}
                                  alt=""
                                  style={{
                                    width: "120px",
                                    height: "120px",
                                    objectFit: "contain",
                                    zIndex: 0,
                                  }}
                                  className="ml-9"
                                />
                              )}
                            <span className="text-center">
                              {renderWithLineBreaks(first.element3Title) ?? ""}
                            </span>
                          </div>

                          {/* First value (first pronostic) */}
                          <div className="text-center text-6xl w-[70px]">
                            {firstValue1}
                          </div>

                          {/* Separator (optional) */}
                          <div className="text-center text-6xl -mx-3">-</div>

                          {/* Second value (second pronostic) */}
                          <div className="text-center text-6xl w-[70px]">
                            {secondValue1}
                          </div>

                          {/* Right visual (from second) */}
                          <div className="flex flex-col w-[100px] mt-auto items-center">
                            {isValidUrl(second.element2Visual) &&
                            second.element2Visual ? (
                              <img
                                src={second.element2Visual}
                                alt=""
                                style={{
                                  width: "120px",
                                  height: "120px",
                                  objectFit: "contain",
                                  zIndex: 0,
                                }}
                                className="mr-9"
                              />
                            ) : null}
                            <span className="text-center">
                              {renderWithLineBreaks(second.element3Title) ?? ""}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
              <div className="flex justify-center w-full">
                <Button
                  style={{
                    backgroundColor:
                      pronosticV2.commonSettings.webApp.moduleSettings
                        .buttonBgColor,
                    color:
                      pronosticV2.commonSettings.webApp.moduleSettings
                        .buttonTextColor,
                    fontWeight: 100,
                  }}
                  onClick={() => {
                    refreshPronosticV2();
                    setCurrentScreen("P4");
                  }}
                >
                  {pronosticV2.commonSettings.webApp.texts.resultsButtonLabel}
                </Button>
              </div>
            </div>
          );
        })();
        break;
      case "P4":
        if (pronosticV2.status === "published") {
          const winnersInfo = pronosticV2.specificSettings.winnersInfo.filter(
            (winner) =>
              winner.subPlaceIndex ===
              (fetchedPlayer?.pronosticInfo?.subPlace || subPlace), // Handle optional subPlace
          );

          const maxWinners =
            pronosticV2?.commonSettings.general.moduleSettings.place?.subPlaces?.find(
              (place) =>
                place.id ===
                (fetchedPlayer?.pronosticInfo?.subPlace || subPlace),
            )?.numberOfWinners;
          console.log("winnersInfo", winnersInfo);

          if (
            winnersInfo.length === 0 ||
            winnersInfo[0]?.winner?.length === 0 ||
            winnersInfo[0]?.winner?.length > maxWinners!
          ) {
            content = (
              <MessageScreen
                message={
                  pronosticV2.commonSettings.webApp.texts.noResultMessage
                }
                buttonLabel={
                  pronosticV2.commonSettings.webApp.texts.backHomeButtonLabel
                }
                buttonBgColor={
                  pronosticV2.commonSettings.webApp.moduleSettings.buttonBgColor
                }
                buttonTextColor={
                  pronosticV2.commonSettings.webApp.moduleSettings
                    .buttonTextColor
                }
                messageColor={
                  pronosticV2.commonSettings.webApp.moduleSettings
                    .messageTitleColor
                }
                messageSize={
                  pronosticV2.commonSettings.webApp.moduleSettings
                    .messageTitleSize
                }
                onClick={() => {
                  setCurrentScreen("P3");
                  refreshPlayer();
                }}
              />
            );
          } else {
            content = (
              <div className="w-full flex flex-col items-center gap-4 mb-4">
                <div
                  style={{
                    color:
                      pronosticV2.commonSettings.webApp.moduleSettings
                        .rankingPageTitleColor,
                    fontSize:
                      pronosticV2.commonSettings.webApp.moduleSettings
                        .rankingPageTitleSize,
                  }}
                  className="flex justify-center -mt-8"
                >
                  {pronosticV2.commonSettings.webApp.texts.rankingPageTitle}
                </div>

                <div className="w-full px-4">
                  {winnersInfo.map((winner) =>
                    winner.winner.map((w, index) => (
                      <div key={`${winner.subPlaceIndex}-${w.rank}-${index}`}>
                        <div className="flex gap-2 sm:gap-4 items-center my-4 w-[60vw] overflow-hidden mx-auto">
                          {" "}
                          <div
                            style={{
                              borderColor:
                                pronosticV2.commonSettings.webApp.moduleSettings
                                  .rankingPageBorderColor,
                            }}
                            className="text-xl sm:text-2xl w-[1.5em] h-[1.5em] p-1 sm:p-2 text-center border-2 rounded-md flex items-center justify-center flex-shrink-0"
                          >
                            {w.rank}
                          </div>
                          <div className="text-xl sm:text-2xl flex-1 min-w-0 px-1 sm:px-2 truncate overflow-hidden whitespace-nowrap">
                            {formatName(w.name)}
                          </div>
                          {pronosticV2.commonSettings.general.moduleSettings
                            .winCondition.type === "PointsCalculation" && (
                            <div className="text-xl sm:text-2xl px-1 sm:px-2 flex-shrink-0">
                              {w.totalScore ?? 0} pts
                            </div>
                          )}
                        </div>
                      </div>
                    )),
                  )}
                </div>

                <div className="flex justify-center mt-8">
                  <Button
                    style={{
                      backgroundColor:
                        pronosticV2.commonSettings.webApp.moduleSettings
                          .buttonBgColor,
                      color:
                        pronosticV2.commonSettings.webApp.moduleSettings
                          .buttonTextColor,
                      fontWeight: 100,
                    }}
                    onClick={() => {
                      setCurrentScreen("P3");
                      refreshPlayer();
                    }}
                  >
                    {
                      pronosticV2.commonSettings.webApp.texts
                        .backHomeButtonLabel
                    }
                  </Button>
                </div>
              </div>
            );
          }
        } else {
          content = (
            <MessageScreen
              message={pronosticV2.commonSettings.webApp.texts.noResultMessage}
              buttonLabel={
                pronosticV2.commonSettings.webApp.texts.backHomeButtonLabel
              }
              buttonBgColor={
                pronosticV2.commonSettings.webApp.moduleSettings.buttonBgColor
              }
              buttonTextColor={
                pronosticV2.commonSettings.webApp.moduleSettings.buttonTextColor
              }
              messageColor={
                pronosticV2.commonSettings.webApp.moduleSettings
                  .messageTitleColor
              }
              messageSize={
                pronosticV2.commonSettings.webApp.moduleSettings
                  .messageTitleSize
              }
              onClick={() => {
                setCurrentScreen("P3");
                refreshPlayer();
              }}
            />
          );
        }
        break;

      default:
        content = <div>Unknown Screen</div>;
    }
  }

  // rendering content - CHANGED: Use theme.fontFamily instead of "inherit"
  return (
    <div style={{ fontFamily: theme.fontFamily }}>
      <Stack
        className="min-h-screen justify-start"
        justify="center"
        align="center"
      >
        {pronosticV2.header?.enabled ? (
          <PronosticHeader pronostic={pronosticV2} />
        ) : (
          <EventHeader />
        )}

        {/* <div className="self-end">
          {pronosticV2.commonSettings.webApp.texts.subPlacePrefixTitle}:{" "}
          {currentSubPlace?.title}
        </div> */}

        {isPlayerLoading ? (
          <div className="flex flex-1 flex-col items-center justify-center">
            <Loader size="lg" />
          </div>
        ) : (
          content
        )}
      </Stack>
      <Footer />
    </div>
  );
};

export default PlayPronosticsV2View;
